// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";

// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCjovlRjazUJEbqAznXiuUBdMLo9nFhI2Q",
  authDomain: "awaketomorroworg.firebaseapp.com",
  projectId: "awaketomorroworg",
  storageBucket: "awaketomorroworg.appspot.com",
  messagingSenderId: "308782397115",
  appId: "1:308782397115:web:550c4e3837333bac26db9e",
  measurementId: "G-F642P1PL3K"
};


// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);
export const db = getFirestore(app);
